import { isEmpty, isObject } from 'lodash';
import omitUndefinedProps from 'sharedParts/utils/omitUndefinedProps';
import defaultSurveyStyles from './defaultSurveyStyles';

// Exporting same structure as `defaultStyles` but with nulled values @sinslav
export default JSON.parse(
  JSON.stringify(defaultSurveyStyles, (key, value) => {
    if (!isObject(value)) {
      return null;
    } else if (isEmpty(omitUndefinedProps(value))) {
      return undefined;
    }
    return value;
  }),
);
